import { FormApi } from 'final-form'
import { noop } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'

import createFocusOnError from './createFocusOnError'
import { TForm } from './types'

export interface TWithFocusOnError extends TForm {
  enableFocusOnErrors?: boolean
}

const withFocusOnError = (WrappedComponent: React.FC<TForm>) => {
  // eslint-disable-next-line react/display-name
  return (props: TWithFocusOnError): React.ReactElement => {
    const {
      setForm = noop,
      name = '',
      decorators = [],
      enableFocusOnErrors,
    } = props
    // @ts-ignore
    const [internalForm, setInternalForm] = useState<FormApi>({})

    const focusOnErrors = useMemo(
      () => createFocusOnError(name, internalForm),
      [internalForm],
    )

    useEffect(() => {
      setForm(internalForm)
    }, [internalForm])

    const internalDecorators = useMemo(() => {
      const result = [...decorators]
      if (enableFocusOnErrors) {
        result.push(focusOnErrors)
      }
      return result.filter(Boolean)
    }, [focusOnErrors, enableFocusOnErrors])

    // TODO: store component ref, and give it to the decorator (to not have to use <form name="..."}>)

    return (
      <WrappedComponent
        {...props}
        setForm={setInternalForm}
        decorators={internalDecorators}
      />
    )
  }
}

export default withFocusOnError
